// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import {Injectable} from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { combineLatest, Observable } from 'rxjs';
import { map, share, switchMap } from 'rxjs/operators';
import { BusinessNavSessionService } from '../session.service';
import { HostService } from './host.service';
import { RequestSubscriptionChangeRequest } from './api';
import { RequestSubscriptionChangeRequestInterface } from './api.interface';

@Injectable({providedIn: 'root'})
export class BusinessApiService {

    constructor(private http: HttpClient, private hostService: HostService, private sessionService: BusinessNavSessionService) {
    }

    private apiOptions(session: string): { headers: HttpHeaders, withCredentials: boolean } {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session}`
            }),
            withCredentials: false
        };
    }

    requestSubscriptionChange(r: RequestSubscriptionChangeRequest | RequestSubscriptionChangeRequestInterface): Observable<boolean> {
        return combineLatest(this.sessionService.sessionId$, this.hostService.hostWithScheme$).pipe(
            switchMap(([session, hostWithScheme]: [string, string]) => {
                const request = ((r as RequestSubscriptionChangeRequest).toApiJson) ? (r as RequestSubscriptionChangeRequest) : new RequestSubscriptionChangeRequest(r);
                return this.http.post<null>(hostWithScheme + '/sales.v1.BusinessService/RequestSubscriptionChange', request.toApiJson(), this.apiOptions(session));
            }),
            map(resp => true),
            share()
        );
    }

}
